export default ({ COLORS }) => ({
  footer: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  cancel: {
    margin: '0 10px 0 0'
  },
  modalContent: {
    minWidth: '400px !important'
  },
  label: {
    color: COLORS.TEXT.MID_GREY.NORMAL,
    display: 'inline-block',
    margin: '0 0 10px'
  },
  row: {
    margin: '20px 0 0',
    '&:first-child': {
      margin: '0'
    }
  }
})
